module.exports = __webpack_public_path__ + "f2bb8a3eb4deedcd80078494924c6dee.svg";